export default "__VITE_ASSET__Yqs6OGWg__"